import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class IdempotencyKeyService {
  private keySubject = new BehaviorSubject<string>(this.generateUniqueKey());
  public key$ = this.keySubject.asObservable();

  public getKey(): string {
    return this.keySubject.value;
  }

  public resetKey(): void {
    this.keySubject.next(this.generateUniqueKey());
  }

  private generateUniqueKey(): string {
    return uuidv4();
  }
}
